<div
  #tabBar
  [class.mobile-tab-bar]="isMobile$ | async"
  [class.mobile-tab-bar--overflowing]="(isMobile$ | async) && isOverflowing"
  [class.mobile-tab-bar--not-overflowing]="(isMobile$ | async) && !isOverflowing">
  <div class="tab-container">
    <button
      *ngFor="let tab of tabs; let tabIndex = index; trackBy: trackByIndex"
      type="button"
      class="tab no-style-button"
      (click)="onTabClicked(tabIndex)"
      [ngClass]="{ active: tab.active }">
      {{ tab.title }}
    </button>
  </div>
</div>
